var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute rounded-full flex items-center justify-center w-6 h-6 md:w-8 md:h-8 md:w-12 md:h-12 right-0 bottom-0",class:`${_vm.bgColor}`},[_c('i',{staticClass:"text-white ds-text-xs md:ds-text-xl",class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }